import { Environment } from '../config/environment';
import { AdultType, ExtraDataType } from './models/Shared.types';
import { Backend } from './Backend';
import { IAssetDetail, ICategoryV5 } from './models/AndromeTV.types';
import { CmsFilterData } from '../Business/cms/actions/CmsFilterTypes';

interface ProductionYearFilter {
  tag?: string[];
  catalogId?: string;
  adult?: AdultType;
}

interface VodCategoryFilter {
  catalogId?: string;
}

export class VodApi {
  static asset(backend: Backend, vodId: string): Promise<IAssetDetail> {
    const url = backend.makeUrl(`vod/v1/vod/${encodeURIComponent(vodId)}`);
    return backend.getJson(url, backend.bearer) as Promise<IAssetDetail>;
  }

  /**
   * Retrieve production years for the specified filter
   */
  static productionYears(backend: Backend, filter: ProductionYearFilter): Promise<number[]> {
    const url = backend.makeUrl('vod/v1/vod/productionyears', filter);
    return backend.getJson(url, backend.bearer) as Promise<number[]>;
  }

  /**
   * Retrieve vod categories
   */
  static vodCategories(backend: Backend, filter: VodCategoryFilter): Promise<ICategoryV5[]> {
    const url = backend.makeUrl('vod/v5/vod-category', filter);
    return backend.getJson(url, backend.bearer) as Promise<ICategoryV5[]>;
  }

  static vodFilterUrl(backend: Backend, filter: CmsFilterData) {
    const queryParam: any = {
      platform: Environment.system,
      catalogId: backend.deviceProfile?.profile.catalog,
      extraData: ExtraDataType.MINI,
      sortBy: 'TITLE',
      sortDir: 'ASC',
      adult: false,
    };
    if (filter.category) {
      queryParam.tag = filter.category.value.filter((x: string) => x !== '*');
    }
    if (filter.year) {
      queryParam.productionYear = filter.year.value;
    }
    if (filter.rating) {
      queryParam.minOperatorScore = filter.rating.value[0];
      queryParam.maxOperatorScore = filter.rating.value[1];
    }
    return backend.makeUrl('vod/v2/cms/vod', queryParam) + '&' + 'page=${page}';
  }
}

// https://tv-api.dev.nebula.androme.com/api/vod/v2/cms/vod?
// https://tv-api.dev.nebula.androme.com/api/vod/v2/cms/vod?
// https://tv-api.dev.nebula.androme.com/api/vod/v5/cms/vod?categoryTag=movies&categoryTag=family&categoryTag=disney&page=0&platformType=SMARTTV_TIZEN&extraData=NONE&sortBy=TITLE&sortDir=ASC
// https://tv-api.dev.nebula.androme.com/api/vod/v5/cms/vod?page=0&platformType=SMARTTV_TIZEN&catalogId=99fa2284-7c37-4bc8-b864-000000000001&extraData=NONE&sortBy=TITLE&sprtDir=ASC&categoryTag=movies&categoryTag=family&categoryTag=disney
